package org.multiplatform.kotfolio.models

import org.multiplatform.kotfolio.util.Constants
import org.multiplatform.kotfolio.util.Res

enum class Portfolio(
    val image: String,
    val title: String,
    val description: String,
    val link: String,
    val language: String,
    val isWeb: Boolean = false,
    val tagList: List<String> = emptyList()
) {
    FlutterCustomerService(
        image = Res.ProjectImage.PORTFOLIO_CUSTOMER_SERVICE,
        title = "Customer Service",
        description = "Service provider client application. On - Demand Home Service, Business Listing, Easy to find. Also, the app shows customer's reviews amd ratings for each service that they make a booking.",
        link = Constants.PROJECT_CUSTOMER_SERVICE_URL,
        language = "Flutter",
        tagList = listOf("Flutter")
    ),

    MoSeC(
        image = Res.ProjectImage.PORTFOLIO_MOSEC,
        title = "MoSeC",
        description = "MoSeC is a multivendor Hybrid Platform Flutter material 3.41.7 designed and Dart 3.11.5, rending the application using impreller for its multitude of vendors to list old mobile and sell their inventory hassle-free. The App experience is as simple as Ready, Set & Go.",
        link = Constants.PROJECT_MOSEC_URL,
        language = "Flutter",
        tagList = listOf("Flutter")
    ),

    FoodCafe(
        image = Res.ProjectImage.PORTFOLIO_FOOD_CAFE,
        title = "Food Cafe",
        description = "FoodCafe (Restaurant admin) Application. This application easy to order manage. Provide the different types of functionality likes order, change order status (pending, accepted, ready, dispatched), notification, new order, pause menu (online order, offline order, different type of recipe not order), turn of ordering (stop order details), new order, kds view (stock view), profile edit, change password, logout etc.",
        link = Constants.PROJECT_FOOD_CAFE_URL,
        language = "Flutter",
        tagList = listOf("Flutter")
    ),

    FlutterServiceProvider(
        image = Res.ProjectImage.PORTFOLIO_SERVICE_PROVIDER,
        title = "Service Provider",
        description = "Service provider admin application. On - Demand Home Service, Business Listing, Easy Booking managment. The provider mobile application allows users to manage their services. Also, the app shows customer's reviews amd ratings for each service that they make a booking.",
        link = Constants.PROJECT_SERVICE_PROVIDER_URL,
        language = "Flutter",
        tagList = listOf("Flutter")
    ),
    MVPEventStaffing(
        image = Res.ProjectImage.PORTFOLIO_MVP_EVENT_STAFFING,
        title = "MVP Event Staffing",
        description = "MVP Event Staffing application provider different types of events likes Staffing Stadiums, Music Festivals, Concerts, and Sporting Events Nationwide.",
        link = Constants.PROJECT_MVP_EVENT_STAFFING_URL,
        language = "Flutter",
        tagList = listOf("Flutter")
    ),

    //KMM
    Attendance(
        image = Res.ProjectImage.PORTFOLIO_ATTENDANCE,
        title = "Attendance",
        description = "Attendance differs significantly from standard academic utilities by prioritizing privacy, local-first data ownership, and seamless user experience. It serves as a sophisticated frontend for your academic life, bridging the gap between legacy university portals (SAP) and modern mobile standards.",
        link = "",
        language = "Kotlin Multiplatform",
        tagList = listOf("Kotlin Multiplatform")
    ),

    ShoppingMall(
        image = Res.ProjectImage.PORTFOLIO_SHOPPING_MALL,
        title = "Shopping Mall",
        description = "E-commerce application using modern Android development technologies. The project features a complete e-commerce business process, including core functions such as user authentication, product display, shopping cart, and order payment, making it suitable for developers to learn and reference modern Android development techniques.",
        link = "",
        language = "Kotlin Multiplatform",
        tagList = listOf("Kotlin Multiplatform")
    ),
}
